<template lang="pug">
  .position-relative.goq-wrapper(v-if="isSupport")
    Header(:url="url")
    .container-fluid.p-0
      .video-chat__area
        Top(:streams="streams")
        Footer
      TextChat
    Alert
    MediaDevice(
      :audioDevices="audioDevices",
      :cameraDevices="cameraDevices"
    )
    GoQApps
    localName
    Icon
  div(v-else)
    UnSupport
</template>

<script>
import '../assets/scss/style.scss'
import Header from '../components/header/Base'
import Top from '../components/top/Base'
import Footer from '../components/footer/Base'
import TextChat from '../components/widget/TextChat'
import Alert from '../components/widget/Alert'
import MediaDevice from '../components/widget/MediaDevice'
import GoQApps from '../components/widget/GoQApps'
import localName from '../components/widget/localName'
import Icon from '../components/widget/Icon'
import UnSupport from '../components/top/UnSupport'
import { checkAppSupport } from '../utils/checkAppSupport'
import createPeer from '../utils/createPeer'

export default {
  name: 'app',
  components: {
    Header,
    Top,
    Footer,
    TextChat,
    Alert,
    MediaDevice,
    GoQApps,
    localName,
    Icon,
    UnSupport
  },
  data () {
    return {
      isSupport: false,
      url: '',
      roomName: '',
      stealth: false,
      localStream: null,
      peer: null,
      room: null,
      audioDevices: [],
      cameraDevices: [],
      streams: [],
      limitFlag: true
    }
  },
  computed: {
    layoutType () {
      return this.$store.state.layout.type
    }
  },
  async created () {
    this.isSupport = checkAppSupport()

    // サポート対象外なら非対応画面が出るので以降の処理をしない
    if (this.isSupport === false) return

    // URL及びURLからルーム名の取得
    this.setLocations()

    // localStorageの値を参照
    const deviceInfo = this.checkLocalStorage()

    if (!this.stealth) {
      // Constraintsの設定
      this.setConstraints(deviceInfo)
      // カメラ・マイクの許可を得る
      this.localStream = await navigator.mediaDevices.getUserMedia(this.$store.state.constraints)
        .then((stream) => {
          return stream
        }).catch((err) => {
          alert('GoQmeを利用するには、カメラ・マイクを許可してください')
          throw new Error(err)
        })

      // 自身のMediaStream切り替えのためにstoreのlocalStreamの置き換え
      this.$store.dispatch('updateLocalStream', { stream: this.localStream })

      this.emurateDevice()
    }

    // Skywayに接続
    this.creatPeerInstance()

    // peerに繋がったらMeshRoomに接続
    this.peer.on('open', (peerId) => {
      // TextChat用に自身のpeerIdを保持
      this.$store.dispatch('updatePeerId', { peerId })

      let options = {
        mode: 'mesh'
      }

      if (!this.stealth) {
        options = {
          mode: 'mesh',
          stream: this.localStream,
          videoBandwidth: 500
        }
      }

      this.room = this.peer.joinRoom(this.roomName, options)

      // storeのroomを置き換え
      this.$store.dispatch('updateRoom', { room: this.room })

      // roomの入退室のイベント監査
      this.setupRoom()
    })

    this.peer.on('error', (err) => {
      // eslint-disable-next-line no-console
      console.log(err)
    })

    // 2時間経過で自動退出
    const limitTime = 2 * 60 * 60 * 1000
    if (this.limitFlag && !['', 'room'].includes(this.roomName)) {
      setTimeout(() => (
        this.exit('一定時間経過したため、ルームを退出しました。')
      ), limitTime)
    }
  },
  methods: {
    setLocations () {
      // ルーム名は第二階層 ※テストはハッシュで行う
      const location = window.location
      this.url = `${location.origin}${location.pathname}`
      this.roomName = location.pathname.split('/')[1]
      const query = location.search

      // FIXME: #obsで見る専になるが、変数名はstealthのまま
      this.stealth = location.hash.split('#')[1] === 'obs'
      this.$store.dispatch('updateStealth', { flag: this.stealth })

      // unlimitedというパラメータがあれば変数planに保持する
      const plan = (query.indexOf('unlimited') !== -1) ? 'unlimited' : ''

      // goqならルーム制限なし
      const noLimitRoomName = 'goq'

      // 制限ありならtrue
      this.limitFlag = !(this.roomName === noLimitRoomName || plan === 'unlimited')

      // FIXME 制限人数（タイルのレイアウトの都合で、現状最大12人まで）
      const limitMembers = this.limitFlag ? 5 : 12

      // 人数制限を更新
      this.$store.dispatch('updatelimitMembers', { length: limitMembers })
    },
    checkLocalStorage () {
      // localStorageに値がある場合、設定でデバイスを選択済みなのでそのデバイスを選択する
      const key = 'goqmeMedia'
      return localStorage.getItem(key) ? JSON.parse(String(localStorage.getItem(key))) : null
    },
    setConstraints (deviceInfo) {
      const audioDeviceId = deviceInfo ? deviceInfo.audio.deviceId : ''
      const videoDeviceId = deviceInfo ? deviceInfo.video.deviceId : ''

      const constraints = {
        audio: {
          deviceId: audioDeviceId
        },
        video: {
          deviceId: videoDeviceId
        }
      }

      // storeのconstraints切り替え
      this.$store.dispatch('updateConstraints', { constraints })
    },
    creatPeerInstance () {
      this.peer = createPeer()
    },
    async emurateDevice () {
      // カメラ・マイクの一覧表示
      await navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          this.audioDevices = devices.filter((device) => device.kind === 'audioinput')
          this.cameraDevices = devices.filter((device) => device.kind === 'videoinput')
        })
    },
    setupRoom () {
      // roomに新しく人が入ってきたら
      this.room.on('peerJoin', (peerId) => {
        // 自分がステルスならsendしない
        if (this.stealth) {
          // サイドバーorポップアップで、他ユーザーがいない場合、新規入室者をメインにする
          if (
            ['sidebar', 'popup'].includes(this.$store.state.layout.type) &&
            this.$store.state.peerId === this.$store.state.layout.mainStreamPeerId
          ) {
            this.updateMainStreamPeerId(peerId)
          }

          return
        }

        const joinMembers = this.$store.getters.joinMembers
        const payload = {
          type: 'join',
          joinMembers,
          peerId
        }

        this.room.send(payload)

        const myPeerId = this.$store.state.peerId
        const localUser = this.$store.getters.localUser

        // 自分のユーザー情報を送る
        this.sendUser(myPeerId, localUser)

        const users = this.$store.state.users
        const sharePeerId = Object.keys(users).find((keys) => users[keys]?.shareFlag)
        const shareUser = users[sharePeerId]

        // 画面共有のホストの場合は、画面共有のユーザー情報を送る
        if (shareUser?.hostPeerId === myPeerId) {
          this.sendUser(sharePeerId, shareUser)
        }
      })

      // 他ユーザのstreamを受信した時
      this.room.on('stream', (stream) => {
        this.addVideo(stream)
      })

      // roomから人が抜けたら
      this.room.on('peerLeave', (peerId) => {
        this.removeVideo(peerId)
        this.$store.dispatch('removeUsers', { peerId })
      })

      // シグナリングデータの受信
      this.room.on('data', (payload) => {
        const data = payload.data
        const actionType = data.type

        this.switchActions({ actionType, data })
      })

      // this.room.on('close', () => {
      // })
    },
    sendUser (peerId, data) {
      // ユーザー情報を送る
      const payload = {
        type: 'users',
        peerId,
        data
      }

      this.room.send(payload)
    },
    addVideo (stream) {
      // 配列につっこんどけばdomは生成される
      this.streams.push(stream)
    },
    removeVideo (peerId) {
      // 同一peerIdのMediaStreamを排除した配列へ
      this.streams = this.streams.filter((stream) => {
        return stream.peerId !== peerId
      })

      const prevMainStreamPeerId = this.$store.state.layout.mainStreamPeerId

      // メイン表示が退室者だった場合、他ユーザーをメインに切り替える（他ユーザーがいなければ自分）
      if (peerId === prevMainStreamPeerId) {
        const mainStreamPeerId = this.streams[0]?.peerId || this.$store.state.peerId

        const layout = {
          mainStreamPeerId
        }

        this.$store.dispatch('updateLayout', { layout })
      }
    },
    updateMainStreamPeerId (peerId) {
      const layout = {
        mainStreamPeerId: peerId
      }

      this.$store.dispatch('updateLayout', { layout })
    },
    switchActions (payload) {
      const { actionType, data } = payload

      switch (actionType) {
        case 'textChat': {
          // チャット
          this.$store.dispatch('updateTextChat', { payload: data })

          // textChatが自動で開くように
          const flag = true
          this.$store.dispatch('updateShowTextChat', { flag })
          break
        }
        case 'join': {
          // 制限なしorステルスモードの場合リターン
          if (!this.limitFlag || this.stealth) return

          const { joinMembers, peerId } = data
          const limitMembers = this.$store.state.limitMembers

          if (joinMembers >= limitMembers && peerId === this.$store.state.peerId) {
            this.room.close()
            alert('このルームは人数の上限に達しています')
            location.href = '/room'
          }
          break
        }
        case 'users':
          this.$store.dispatch('updateUsers', { payload: data })

          // ユーザーが共有画面の場合、レイアウトをサイドバーにして、メイン表示を共有画面に変更
          if (data.data?.shareFlag) {
            const layout = {
              type: 'sidebar',
              mainStreamPeerId: data.peerId
            }
            this.$store.dispatch('updateLayout', { layout })
          }
          break
        case 'exit':
          // 退出させられる
          if (data.peerId === this.peer.id) {
            this.exit('ルームを退出しました。')
          }
          break
        default:
          break
      }
    },
    exit (text) {
      this.room.close()
      alert(text)
      location.href = '/room'
    }
  }
}
</script>
